/** Normalized visible-page coordinates: a reference's area, as the gateway reads it (ml-services src/agent/reads.ts). */
export interface DocumentRegion { x: number; y: number; width: number; height: number }
export const documentRegionSchema = {
    type: 'object',
    properties: Object.fromEntries(['x', 'y', 'width', 'height'].map(key => [key, { type: 'number', minimum: 0, maximum: 1 }])),
    required: ['x', 'y', 'width', 'height'], additionalProperties: false,
};
export const documentRenderSchema = { type: 'boolean' };
